import React, { useContext } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';
import { TransactionType } from '@/modules/transactions/api/transactions/transaction.contracts';
import { useTranslation } from '@/lib';
import { getTransactionTypeStyle } from '@/modules/transactions/types/TransactionModel';

interface TransactionTypeFilterProps {
  label: string;
}

const TransactionTypeFilter: React.FC<TransactionTypeFilterProps> = ({ label }) => {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (value === '') {
      setFilterValue(FilterFieldName.transactionType, undefined);
    } else {
      const transactionType = value as TransactionType;
      // Get the human-readable translation (capitalized)
      const humanValue = t(transactionType.toLowerCase());
      setFilterValue(FilterFieldName.transactionType, transactionType, humanValue);
    }
  };

  const handleClear = () => {
    setFilterValue(FilterFieldName.transactionType, undefined);
  };

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        value={filterValues.transactionType || ''}
        onChange={handleChange}
        label={label}
        endAdornment={
          filterValues.transactionType && (
            <IconButton className="absolute right-3 mr-6 flex" color="inherit" onClick={handleClear} aria-label="clear" size="small">
              <Clear />
            </IconButton>
          )
        }
      >
        <MenuItem value={TransactionType.Transfer}>
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${
              getTransactionTypeStyle(TransactionType.Transfer).bg
            } ${getTransactionTypeStyle(TransactionType.Transfer).text}`}
          >
            {t('transfer')}
          </span>
        </MenuItem>
        <MenuItem value={TransactionType.Correction}>
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${
              getTransactionTypeStyle(TransactionType.Correction).bg
            } ${getTransactionTypeStyle(TransactionType.Correction).text}`}
          >
            {t('correction')}
          </span>
        </MenuItem>
        <MenuItem value={TransactionType.System}>
          <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${getTransactionTypeStyle(TransactionType.System).bg} ${
              getTransactionTypeStyle(TransactionType.System).text
            }`}
          >
            {t('system')}
          </span>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default TransactionTypeFilter;
